import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { MetricCard } from '../components/MetricCard';
import { fmtNum, fmtInt, fmtDate, humanInterval } from "../utils/formatting";
import { Spinner } from "../components/Spinner";


export const MetricDetail = ({config}) => {
  const { metricName } = useParams();
  const [metricDetails, setMetricDetails] = useState(null);
  const [metricData, setMetricData] = useState([]);

  // fetch metric details using metricName if needed
  // curl -X 'GET' \
  // 'http://localhost:8000/metricsoverview/SOFR' \
  // -H 'accept: application/json'
  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch(`${config.apiBaseUrl}/metricsoverview/${metricName}`, {
        headers: {
          accept: "application/json"
        }
      });
      // Handle response
      const data = await res.json();
      setMetricDetails(data.metric);
      setMetricData(data.resultsData.data || []);
      // console.log(`Fetched metric details: ${JSON.stringify(data)}`)
    };
    fetchData();
  }, [metricName]);

  return (
    <>
      <div style={{ textAlign: 'left', marginTop: '0rem' }}>
        {metricDetails ? (
          <div className="p-3 flex flex-col items-start">
            <Link to="/metrics" className="mt-4 text-white underline mb-2">
              &lt; Back to Metrics
            </Link>
            {/* <pre className="text-left bg-gray-800 p-4 rounded-lg overflow-x-auto">
              {JSON.stringify(metricDetails, null, 2)}
            </pre> */}
            <MetricCard
                key={metricDetails.name}
                name={metricDetails.name}
                firstTs={metricDetails.first_ts}
                lastTs={metricDetails.last_ts}
                latestTs={metricDetails.latest_ts}
                description={metricDetails.description}
                count={metricDetails.count}
                minValue={metricDetails.min_value}
                maxValue={metricDetails.max_value}
                avgValue={metricDetails.avg_value}
                hasLabels={metricDetails.has_labels}
                avgIntervalSeconds={metricDetails.avg_interval_seconds}
                pointsPerDay={metricDetails.points_per_day}
                latestValue={metricDetails.latest_value}
                latestLabels={metricDetails.latest_labels}
                fmt={{ fmtNum, fmtInt, fmtDate, humanInterval }}
                enableNavigate={false}
                showChart={true}
                data={metricData}
              />

          </div>
        ) : (
          <div className='p-10 flex flex-col items-center justify-center gap-3'>
            <Spinner/><p className="text-gray-400">Loading...</p>
            </div>
        )}
      </div>
    </>
  );
};

